import React from 'react'
import LineClockDollarIcon from 'components/Luxkit/Icons/line/LineClockDollarIcon'
import Pill from 'components/Luxkit/Pill'
import { useTranslation } from 'react-i18next'

interface Props {
  testId?: string;
}
function SecureWithDepositTag(props: Props) {
  const { testId } = props
  const { t } = useTranslation('offerList')
  return (
    <Pill data-testid={testId} kind="tertiary" variant="primary" startIcon={<LineClockDollarIcon />}>{t('Secure with a deposit', { ns: 'offerList' })}</Pill>
  )
}
export default React.memo(SecureWithDepositTag)
